import { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../utils/context/app-context';
import { useNavigate } from 'react-router-dom';
import useBrowserStorage from '../hooks/use-browser-storage';
import AuthService from '../services/auth.service';

const ProfileSettings = () => {
  const [showUserInfoMenu, setShowUserInfoMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const { userInfo } = useAppContext();
  const navigate = useNavigate();
  const { removeItem, getItem } = useBrowserStorage();
  const logout = async () => {
    try {
      // const sessionId = getItem('sessionId', 'local');
      const logoutRes = await AuthService.signOut();
      if (!logoutRes.data.error) {
        removeItem('userInfo', 'local');
        navigate('/auth');
      }
      // removeItem('userInfo', 'local');
      // removeItem('sessionId', 'local');
      // navigate('/');
    } catch (err) {
      console.log('Not able to logout');
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserInfoMenu(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <div className="relative">
      {showUserInfoMenu && (
        <div
          ref={menuRef}
          className="w-[240px] text-[16px] rounded-xl bg-white dark:bg-[#212121] p-3 absolute left-[10px] bottom-[80px] shadow-md z"
        >
          <div
            className="
            p-3 border-b-[#ebebeb] dark:border-b-[#444] overflow-hidden truncate
            border-b text-wrap text-sm text-[#999] dark:text-[#ededed] text-center
          "
          >
            {userInfo?.email}
          </div>
          <ul>
            <li
              className="
                p-3 flex items-center hover:bg-[#f7f7f7]
                dark:hover:bg-[#424242] cursor-pointer
              "
              onClick={() => {
                navigate('/change-password');
                setShowUserInfoMenu(false);
              }}
            >
              <i className="icon-settings dark:text-[#ededed]"></i>
              <span className="ml-2 dark:text-[#ededed]">Change Password</span>
            </li>

            <li
              className="p-2 flex items-center hover:bg-[#f7f7f7] cursor-pointer dark:hover:bg-[#424242]"
              onClick={logout}
            >
              <i className="icon-logout dark:text-[#ededed]"></i>
              <span className="ml-2 dark:text-[#ededed]">Logout</span>
            </li>
          </ul>
        </div>
      )}
      <div
        className="bg-[#f3f3f3] dark:bg-[#212121] px-5 py-4 w-full flex items-center justify-between cursor-pointer"
        onClick={() => setShowUserInfoMenu(true)}
      >
        {/* <UserAvatar size={UserAvatarSize.SMALL} /> */}
        <div className="text-[#64645f] dark:text-[#bdbdbd] text-sm font-normal">
          {`${userInfo?.firstName} ${userInfo?.lastName}`}
        </div>
        <div className="text-[#64645f] dark:text-[#bdbdbd] text-sm font-normal">
          <i className="icon-settings"></i>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;